var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnLockSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4444 26.5H7.55556C4.48731 26.5 2 29.7303 2 33.715V58.9675C2 62.9523 4.48731 66.1825 7.55556 66.1825H46.4444C49.5127 66.1825 52 62.9523 52 58.9675V33.715C52 29.7303 49.5127 26.5 46.4444 26.5Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1113 27V15.8889C13.1113 12.2053 14.5746 8.67263 17.1793 6.06796C19.784 3.46329 23.3167 2 27.0002 2C30.6838 2 34.2165 3.46329 36.8211 6.06796C39.4258 8.67263 40.8891 12.2053 40.8891 15.8889V27",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40.5L24 51.5L19 46.5",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLockSuccess);
export default __webpack_public_path__ + "static/media/icn-lock-success.8c9060c083fc8d8eb9f088e9b1433d5e.svg";
export { ForwardRef as ReactComponent };